@if (cardInfo) {
  <div class="activity-card-meeting">
    <mat-card class="bottom-card">
      <mat-card-header [style.margin-left]="!showAvatar ? (AVATAR_WIDTH + 16).toString() + 'px' : null">
        @if (showAvatar) {
          <div matCardAvatar>
            <glxy-avatar
              [width]="AVATAR_WIDTH"
              icon="calendar_today"
              backgroundColor="var(--primary-background-color)"
              textColor="#9E9E9E"
            ></glxy-avatar>
          </div>
        }
        <mat-card-title>
          @if (headerText$() | async; as headerText) {
            <span class="title">
              {{ headerText }}
            </span>
          } @else {
            <span class="loading-header-text stencil-shimmer"></span>
          }
        </mat-card-title>
        <mat-card-subtitle>
          @if (cardInfo.date !== null) {
            <p class="effective-date">
              {{ cardInfo.date | date: dateFormat }}
            </p>
          }
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content [style.margin-left]="(AVATAR_WIDTH + 16).toString() + 'px'">
        <mat-card appearance="outlined" class="inner-card">
          @if (!cardInfo.meetingSummaryTitle) {
            <mat-card-title class="mat-card-title meeting-title">
              @if (cardTitle(); as cardTitle) {
                <span>{{ cardTitle }}</span>
              }
            </mat-card-title>
          }
          <mat-card-content [style.margin-left]="-(AVATAR_WIDTH - 36).toString() + 'px'">
            @if (cardInfo.meetingSummaryBody || cardInfo.meetingSummaryTitle) {
              @if (cardInfo.meetingSummaryTitle) {
                <div class="meeting-summary-title">
                  <div [innerHTML]="cardInfo.meetingSummaryTitle" class="summary-title"></div>
                </div>
              }
              @if (cardInfo.meetingSummaryBody) {
                <div class="summarized-by-ai">
                  <div class="summary-by-ai">
                    <mat-icon class="ai-icon" svgIcon="galaxy-ai-icon" />
                    <div>{{ 'ACTIVITY.MEETING.SUMMARY_BY_AI' | translate }}</div>
                  </div>
                  <div class="meeting-summary-body">
                    <span [innerHTML]="cardInfo.meetingSummaryBody"></span>
                  </div>
                  <a data-action="”view-summary-link-clicked”" class="view-summary-link" (click)="openSummaryModal()">{{
                    'ACTIVITY.MEETING.MEETING_ANALYSIS.VIEW_SUMMARY' | translate
                  }}</a>
                </div>
              }
            } @else {
              @if (cardInfo.meetingBody) {
                <div>
                  <crm-collapsible-section [maxHeightPx]="100">
                    <span class="meeting-body" [innerHTML]="cardInfo.meetingBody"></span>
                  </crm-collapsible-section>
                </div>
              }
            }
            <div class="row meeting-details">
              <ng-container
                [ngTemplateOutlet]="activityData"
                [ngTemplateOutletContext]="{ label: 'ACTIVITY.DATE', value: cardInfo.date | date: dateFormat }"
              ></ng-container>
              @if (cardInfo.meetingDuration) {
                <ng-container
                  [ngTemplateOutlet]="activityData"
                  [ngTemplateOutletContext]="{ label: 'ACTIVITY.DURATION', value: cardInfo.meetingDuration }"
                ></ng-container>
              }
              @if (cardInfo.meetingSalesScore) {
                <ng-container
                  [ngTemplateOutlet]="activityData"
              [ngTemplateOutletContext]="{
                label: 'ACTIVITY.MEETING.RAVEN_SCORE',
                value: cardInfo.meetingSalesScore + '/25',
              }"
                ></ng-container>
              }
              @if (!cardInfo.meetingSummarySentiment) {
                <ng-container
                  [ngTemplateOutlet]="activityData"
                  [ngTemplateOutletContext]="{ label: 'ACTIVITY.STATUS', value: cardInfo.meetingStatus }"
                ></ng-container>
              }
              @if (cardInfo.meetingLocation) {
                <ng-container
                  [ngTemplateOutlet]="activityData"
                  [ngTemplateOutletContext]="{ label: 'ACTIVITY.LOCATION', value: cardInfo.meetingLocation }"
                ></ng-container>
              }
              @if (cardInfo.meetingSummarySentiment) {
                <ng-container
                  [ngTemplateOutlet]="activityData"
              [ngTemplateOutletContext]="{
                label: 'ACTIVITY.MEETING.SENTIMENT_SCORE',
                value: cardInfo.meetingSummarySentiment + '/10',
              }"
                ></ng-container>
              }
            </div>
            <crm-association-popover [hideDivider]="true"></crm-association-popover>
          </mat-card-content>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
}

<ng-template #activityData let-label="label" let-value="value">
  <div class="col col-xs-12 col-md-3">
    <div class="activity-data-label">
      {{ label | translate }}
    </div>
    <div class="activity-data-value">
      <!-- ng-container necessary so angular interpolation will add empty -->
      @if (value) {
        {{ value }}
      }
    </div>
  </div>
</ng-template>
